import React, { useState, useEffect } from "react";
import "./SelectedSession.css";
import TranscriptView from "../selectedSessionComponent/TranscriptView";
import { TabHeader } from "../selectedSessionComponent/TabHeader";
import { SummaryView } from "../selectedSessionComponent/SummaryView";
import LetterView from "../selectedSessionComponent/LetterView";
import GenerateLetterModal from "../selectedSessionComponent/GenerateLetterModal";
import usePatientStore from "../../store/usePatientStore";
import SummaryPop from "../selectedSessionComponent/SummaryPopup";
import { CircularProgress } from "@mui/material";
import LoadingScreen from "../selectedSessionComponent/NoSummary";
import useUserStore from "../../store/useUserStore";
import { ArrowLeft, FileText, SortAsc } from "lucide-react";
import FeedbackModal from "../selectedSessionComponent/FeedbackModal";

export default function SelectedSession() {
  const [activeTab, setActiveTab] = useState("transcript");
  const [showLetterModal, setShowLetterModal] = useState(false);
  const [letterType, setLetterType] = useState(null);
  const [summaries, setSummaries] = useState([]);
  const [selectedType, setSelectedType] = useState("1");
  const { activePage, isMobile, setActivePage } = useUserStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    currentSession,
    transcript,
    final_summary,
    audio_url,
    summary1,
    summary2,
    summary3,
    sopnotes,
    doctor_letter,
    surgicalNote,
    consultationId,
    setTranscriptData,
    getConsultationDetail,
    setFinalSummary,
    loading,
    decreaseUnread,
    setLoading,
  } = usePatientStore();
  const [showPopUp, setShowPopUp] = useState(false);

  useEffect(() => {
    console.log(currentSession);
    if (final_summary === summary1) {
      setSelectedType("0");
    } else if (final_summary === summary2) {
      setSelectedType("1");
    } else if (final_summary === sopnotes) {
      setSelectedType("2");
    }
  }, []);

  useEffect(() => {
    setLetterType(null);
    setActiveTab("transcript");
  }, [consultationId]);

  const handleGenerateLetter = (type) => {
    setShowLetterModal(false);
    setLetterType(type);
    setActiveTab(`${type.toLowerCase()}-letter`);
  };


  const handleFeedbackSave = (feedback) => {
    console.log('Feedback received:', feedback);
    setIsModalOpen(false); // Close the modal after saving
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };


  const updateTransciptSummary = async (consultationId, content, fileType,isEdited=false) => {
    setLoading(true);
    const url = `${process.env.REACT_APP_SERVER_URL}/consultations/updatefile/${consultationId}`;

    // Convert string to Blob and create a File object
    const blob = new Blob([content], { type: "text/plain" });
    const file = new File(
      [blob],
      `${fileType.replace(" ", "_").toLowerCase()}.txt`,
      { type: "text/plain" }
    );

    // Prepare FormData
    const formData = new FormData();
    formData.append("file_type", fileType);
    formData.append("isEdited",isEdited)
    formData.append("file", file);

    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
        },
        body: formData,
      });

      if (!response.ok) {
        setLoading(false);
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const result = await response.json();
      console.log("File updated successfully:", result);
      await getConsultationDetail(consultationId);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error updating file:", error);
    }
  };

  const handleUpdateSummary = async (consultationId, content, fileType) => {
    await updateTransciptSummary(consultationId, content, fileType,true);

    setSummaries((prevSummaries) => {
      const newSummaries = [...prevSummaries];
      newSummaries[selectedType] = content;
      return newSummaries;
    });

    setFinalSummary(content); // Assuming setFinalSummary updates the state
  };

  const handleUpdateTranscript = async (consultationId, content, fileType) => {
    // Call your API or service to update the transcript
    await updateTransciptSummary(consultationId, content, fileType,true);

    // Update the state for the transcript using setTranscriptData
    setTranscriptData(content); // Use setTranscriptData here
  };


  useEffect(() => {
    setSummaries([summary1, summary2, sopnotes]);
    if (!final_summary && (summary1 || summary2 || sopnotes)) {
      setShowPopUp(true);
      decreaseUnread();
    }
  }, [transcript]);

  // useEffect(() => {
  //   setSummaries([summary1, summary2, sopnotes]);
  //   if ((!currentSession?.is_final_summary_generated) && currentSession?.is_summary_generated) {
  //     setShowPopUp(true);
  //     decreaseUnread();
  //   }
  // }, [transcript]);

  const onConfirm = async (index) => {
    setShowPopUp(false);
    setActiveTab("summary");
    await updateTransciptSummary(
      consultationId,
      summaries[index],
      "Final Summary",
      false
    );
    await getConsultationDetail(consultationId);
  };

  const renderActiveComponent = () => {
    switch (activeTab) {
      case "transcript":
        return (
          <TranscriptView
            audioUrl={audio_url}
            transcript={transcript}
            consultationId={consultationId}
          />
        );
      case "summary":
        return (
          <SummaryView
            summary={final_summary}
            consultationId={consultationId}
            onUpdateSummary={handleUpdateSummary}
            setShowPopUp={setShowPopUp}
            selectedType={selectedType}
          />
        );
      case "patient-letter":
        return <LetterView type={letterType} letter={summary3} consultationId={consultationId} updateTransciptSummary={updateTransciptSummary} />;
      case "doctor-letter":
        return <LetterView type={letterType} letter={doctor_letter} consultationId={consultationId} updateTransciptSummary={updateTransciptSummary}/>;
      default:
        return null;
    }
  };

  return (
    <div
      className={`selected-session ${
        isMobile
          ? activePage === "selected-session"
            ? "selected-session-mobile"
            : "selected-session-hidden-mobile"
          : " "
      }`}
    >
      {/* Header Section */}
      <div className="header">
        <div className="arrow-wrapper">
          {isMobile && (
            <button
              className="arrow-btn"
              onClick={() => setActivePage("sidebar")}
            >
              <ArrowLeft />
            </button>
          )}
          <h1 className="page-title">Patient Details</h1>
        </div>
        <div className="feedback-wrapper">
          <h2 className="patient-name">{currentSession?.patient_name}</h2>
          <button onClick={() => setIsModalOpen(true)} className="feedback-btn">
            <FileText size={18} />
            Give Feedback
          </button>
        </div>
      </div>

      <div className="tab-section">
        <TabHeader
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setShowLetterModal={setShowLetterModal}
          letterType={letterType}
        />
      </div>

      <div className="summary-transcript-view">
        {loading ? (
          <CircularProgress
            size={60}
            sx={{ position: "relative", top: "35%", left: "40%" }}
          />
        ) : summary1 || summary2 || sopnotes ? (
          <>{renderActiveComponent()}</>
        ) : (
          <LoadingScreen message={"Summary and Transcript"}/>
        )}
      </div>
      {isModalOpen && (
        <FeedbackModal onClose={handleModalClose} onSave={handleFeedbackSave} />
      )}
      {showLetterModal && (
        <GenerateLetterModal
          onClose={() => setShowLetterModal(false)}
          onGenerate={handleGenerateLetter}
        />
      )}
      {showPopUp && !loading && (
        <SummaryPop
          onConfirm={onConfirm}
          summaries={[summary1, summary2, sopnotes]}
          setSelectedType={setSelectedType}
          selectedType={selectedType}
        />
      )}
    </div>
  );
}
